import {InjectionToken} from '@angular/core';

/**
 * Interface that any component hosting `appSegmentDataObserver` must implement.
 * Add here whatever properties/methods the directive needs to read or call on the host.
 */
export interface SegmentDataObserverHost {
    // example — extend as needed:
    // segmentId: string;
    // onSegmentLoaded(): void;
    onAccountDataChanged?(): void;
}

export abstract class SegmentDataObserverHostBase implements SegmentDataObserverHost {

}

/**
 * Runtime token that replaces the interface for DI purposes.
 * Host components must provide themselves via this token.
 *
 * @example
 * // in the host component decorator:
 * providers: [{ provide: SEGMENT_DATA_OBSERVER_HOST, useExisting: forwardRef(() => MyComponent) }]
 */
export const SEGMENT_DATA_OBSERVER_HOST =
    new InjectionToken<SegmentDataObserverHost>('SEGMENT_DATA_OBSERVER_HOST');

